import React from 'react'
import { toDateKey } from '../allocationUtils'

/**
 * DailyTimelineHeader
 * -------------------
 * Renders the top X-axis for the Daily Timeline view (Full 24-hour timeline 12 AM to 12 PM to 12 AM).
 * Highlights the current hour column when viewing today.
 */
export default function DailyTimelineHeader({ hours, slotWidth, selectedDay }) {
  const isToday = selectedDay && toDateKey(selectedDay) === toDateKey(new Date())
  const currentHour = new Date().getHours()

  return (
    <div
      className="flex border-b border-outline-variant/40 bg-surface-container-lowest/90 backdrop-blur-xs select-none sticky top-0 z-10"
      style={{ width: `${hours.length * slotWidth}px`, minWidth: `${hours.length * slotWidth}px` }}
    >
      {hours.map(({ hour, label }) => {
        const isCurrentHourSlot = isToday && currentHour === hour

        return (
          <div
            key={hour}
            className={`flex-shrink-0 flex flex-col items-center justify-center py-2.5 border-r border-outline-variant/30 text-center transition-colors ${
              isCurrentHourSlot ? 'bg-primary/5 text-primary font-bold' : 'text-on-surface-variant/80'
            }`}
            style={{ width: `${slotWidth}px` }}
          >
            <div className="flex items-center gap-1">
              <span className="text-xs font-semibold tracking-tight">{label}</span>
              {isCurrentHourSlot && (
                <span className="w-1.5 h-1.5 rounded-full bg-primary animate-pulse" title="Current time" />
              )}
            </div>
            <span className="text-[10px] text-outline font-normal">
              {String(hour).padStart(2, '0')}:00 – {hour === 23 ? '24:00' : `${String(hour + 1).padStart(2, '0')}:00`}
            </span>
          </div>
        )
      })}
    </div>
  )
}
